<template>
  <div>
    <bb-row class="gutter-10">
      <bb-col v-if="!$isFi()" col="12">
        <bb-button
          id="startMobileIdVerificationButton"
          inverted
          class="p-x-10 w-100"
          color="gray"
          icon="client-mobile-id"
          :label="$t('digitalAuthenticationMethods.mobileId')"
          size="md"
          :icon-size="24"
          @click="startVerification(verificationMethods.MOBILE_ID)"
        />
      </bb-col>
      <bb-col v-if="!$isFi()" col="12">
        <bb-button
          id="startSmartIdVerificationButton"
          inverted
          class="p-x-10 w-100"
          color="gray"
          icon="client-smart-id"
          :label="$t('digitalAuthenticationMethods.smartId')"
          size="md"
          :icon-size="24"
          @click="startVerification(verificationMethods.SMART_ID)"
        />
      </bb-col>
      <bb-col v-if="$isEe()" class="m-t-10">
        <bb-button
          id="startIdCardVerificationButton"
          inverted
          class="p-x-10 w-100"
          color="gray"
          icon="ui-credit-card-outline"
          :label="$t('digitalAuthenticationMethods.idCard')"
          size="md"
          :icon-size="24"
          @click="startVerification(verificationMethods.ID_CARD)"
        />
      </bb-col>
    </bb-row>
    <smart-id-plus-modal
      :visible="showSmartIdPlusModal"
      :qr-code="qrCode"
      @initiate-authentication="initiateAuthentication"
      @open-mobile-app="initiateMobileAppSmartIdAuthentication"
      @close="closeModal"
    />
    <authentication-modal
      :visible="showAuthenticationModal"
      :loading="loading"
      :active-verification-method="activeVerificationMethod"
      :personal-identity-code.sync="personalIdentityCode"
      :mobile-number.sync="mobileNumber"
      @initiate-authentication="initiateAuthentication"
      @close="closeModal"
    />
    <smart-id-challenge-id-modal
      :visible="!!challengeId && !isSmartIdPlusEnabled"
      :challenge-id="challengeId"
      :active-verification-method="activeVerificationMethod"
      @close="closeModal"
    />
  </div>
</template>
<script>
  import {
    BbRow,
    BbCol,
    BbButton,
  } from '@bigbank/interface-components';
  import SmartIdPlusModal from './authentication/SmartIdPlusModal.vue';
  import AuthenticationModal from '@/components/common/authentication/AuthenticationModal.vue';
  import SmartIdChallengeIdModal from '@/components/common/authentication/SmartIdChallengeIdModal.vue';
  import '@bigbank/interface-components/dist/svg/client/smart-id';
  import '@bigbank/interface-components/dist/svg/client/mobile-id';
  import '@bigbank/interface-components/dist/svg/ui/credit-card-outline';
  import { VerificationMethods } from '@/types/common/enums';
  import { isSmartIdPlusAuthenticationEnabled } from '@/utils/common/config';

  export default {
    name: 'digital-authentication-methods',
    components: {
      BbRow,
      BbCol,
      BbButton,
      SmartIdPlusModal,
      AuthenticationModal,
      SmartIdChallengeIdModal,
    },
    props: {
      verificationCode: {
        type: String,
      },
      qrCode: {
        type: String,
      },
      loading: {
        'type': Boolean,
        'default': false,
      },
      closeAuthenticationModal: {
        'type': Boolean,
        'default': false,
      },
    },
    data () {
      return {
        verificationMethods: VerificationMethods,
        activeVerificationMethod: null,
        showModal: false,
        mobileNumber: '',
        personalIdentityCode: '',
        challengeId: null,
      };
    },
    computed: {
      isSmartIdPlusEnabled () {
        return isSmartIdPlusAuthenticationEnabled();
      },
      showSmartIdPlusModal () {
        return this.isSmartIdPlusEnabled &&
          this.activeVerificationMethod === VerificationMethods.SMART_ID &&
          this.showModal;
      },
      showAuthenticationModal () {
        return (!this.isSmartIdPlusEnabled || this.activeVerificationMethod !== VerificationMethods.SMART_ID) &&
          this.showModal &&
          !this.challengeId;
      },
    },
    watch: {
      verificationCode (val) {
        this.challengeId = val;
      },
      closeAuthenticationModal (val) {
        if (val) {
          this.closeModal();
        }
      },
    },
    methods: {
      startVerification (method) {
        if (method === VerificationMethods.ID_CARD) {
          this.activeVerificationMethod = method;

          return this.$emit('initiateIdCardAuthentication');
        }

        this.activeVerificationMethod = method;
        this.showModal = true;
      },
      initiateAuthentication () {
        this.$emit('initiateDigitalAuthentication', {
          method: this.activeVerificationMethod,
          personalIdentityCode: this.personalIdentityCode,
          phoneNumber: this.mobileNumber,
        });
      },
      initiateMobileAppSmartIdAuthentication() {
        this.$emit('initiateWeb2AppAuthentication');
      },
      closeModal () {
        this.showModal = false;
        this.$nextTick(() => {
          this.mobileNumber = '';
          this.personalIdentityCode = '';
          this.challengeId = null;
          this.$emit('stopDigitalAuthentication');
        });
      },
    },
  };
</script>
